import { render } from "./Video.vue?vue&type=template&id=e0a9f25a"
import script from "./Video.vue?vue&type=script&lang=ts"
export * from "./Video.vue?vue&type=script&lang=ts"
script.render = render

export default script